<template>
<div ref="SheduleEdit">    
    <div class="TTL-el-form-search-regular">
        <span class="TTL-title">编辑日程类型</span>
        <div class="TTL-button TTL-btn-option">
        <el-badge :value="typelist.length > 1 ? typelist.length : ''" class="item">
        <el-button @click="submitData">提交数据</el-button>
        </el-badge>
        </div>
        <div class="TTL-button TTL-btn-option">
        <el-button type="del" @click="GoBackPets(false)">返回日程管理</el-button>
        </div>
    </div>
    
    <div>
        <div class="TTL-form-submit-box " v-for="(item,index) in typelist" :key="index">
            <div class="TTL-form-submit-box-title">日程类型-{{index+1}}</div>
            <el-form :inline="false">
                <el-form-item>
                    <label class="TTL-form-label">默认日程类型图（未选中时的图）</label>
                    <wcupload :option="{size:'large', phototype:'system'}" :value="item.thumbdefault" 
                        @finish="(val)=> {
                            item.thumbdefault=val.url;
                        }" 
                    />
                </el-form-item>
                <el-form-item>
                    <label class="TTL-form-label">日程类型图（选中状态下的图）</label>
                    <wcupload :option="{size:'large', phototype:'system'}" :value="item.thumb" 
                        @finish="(val)=> {
                            item.thumb=val.url;
                        }" 
                    />
                </el-form-item>
                <el-form-item>
                    <label class="TTL-form-label">一级类型</label>
                    <div class="TTL-select">
                    <el-select v-model="item.pid" placeholder="请选择宠物类型" @change="SaveDataToBrowser" filterable :disabled="item.pid==0 ? true : false">
                    <el-option v-for="(item,index) in fatherlist" :key="index" :label="item.name" :value="item.id" />
                    </el-select>
                    </div>
                </el-form-item>
                <el-form-item>
                    <label class="TTL-form-label">名称<i>*</i></label>
                    <div class="TTL-input width300 TTL-form-input">
                    <el-input v-model="item.name" placeholder="请输入宠物名称" @change="SaveDataToBrowser" clearable />
                    </div>
                </el-form-item>

            </el-form>
        </div>
    </div>
</div>
</template>

<script>
import INTERFACE_MODEL_PETS from '@/Interface/Pets/Schedule';
import INTERFACE_MODEL_BASE from '@/Interface/index';
export default {
    components:{},
    data() {
        return {
            type:'edit',
            file:'',             //图片变量，占位符
            addlimit: 10,        //单次新增限制
            defaultIndex:'',     //默认index
            uploadimageIndex:'', //获取当前上传图片的序号
            fatherlist:[],       //一级类型信息
            typelist:[{name:'',thumb:'',thumbdefault:'',pid:''}],
        }
    },
    mounted() {
        this.OnloadMethod(); //页数初始化
    },
    methods: {

        /** 修改页面显示标签信息 **/
        ChangePageLabel() {
            
        },

        /** 页数初始化 **/
        OnloadMethod() {
            this.GetParentTypes();       //获取一级类型信息
        },


        /** 其它组件调用当前组件进行数据传递 **/
        BrotherComponentIn(data) {
            if(data.isask) {          //兄弟组件跳转至当前组件时进行询问操作
                this.$confirm.confirm('当前有数据正在执行编辑操作，是否要执行覆盖操作 ？','操作提示',{confirmButtonText:'确定',cancelButtonText:'取消',type: 'warning'}).then(()=> {
                    this.GetSheduleTypeInfo(data.ids); //获取待处理宠物
                }).catch(()=> {
                    
                });
            }else if(data.reload) {   //浏览器重新刷新时执行的操作
                
            }else {
                this.GetSheduleTypeInfo(data.ids);   //获取待编辑的提醒类型
            }
        },


        /** 提交数据 **/
        submitData() {
            var checkresult=this.CheckDataBeforeSubmit();
            if(checkresult.error==1) {this.$notice({title:'提交数据提示',message:checkresult.message,type:'warning'});return false;}

            //调整提交数据
            var data=[];
            for(var i=0;i<this.typelist.length;i++) data.push(this.typelist[i]);
            data=JSON.stringify(data);

            var loadingobj=this.$refs.SheduleEdit;
            this.$loading.openloading(loadingobj);  //加载等待动画

            INTERFACE_MODEL_PETS.EDIT_SCHDULE_TYPE({typedata:data}).then((res) => {
                this.$loading.closeloading(loadingobj);
                if(res.status > 0) return false;
                this.resetParam(); //重置当前数据
                this.$notice({title:'成功提示',message:'数据提交成功',type:'success'});
                this.SaveDataToBrowser(); //保存编辑完成之后的数据信息到浏览器
            });
        },


        /** 数据提交前进行检测 **/
        CheckDataBeforeSubmit() {
            var result={error:0,message:''};
            if(this.typelist.length==0) {result={error:1,message:'请添加类型信息'};return result;}

            //检测品种参数
            var name;
            for(var i=0;i < this.typelist.length;i++) {
                name=this.typelist[i].name;
                if(!name || name=='') {result={error:1,message:'第'+(i+1)+'个类型名称不能为空'};return result;}
            }
            return result;
        },



        /** 重置加载数据 **/
        resetParam() {
            var data={name:'',thumb:'',thumbdefault:'',pid:''};
            this.typelist=[data];
        },


        /////////////////////////////////////////////////////////////////
        ////////////////////////////////////////////////////////////////
        //关联基础数据加载

        /** 获取日程类型信息 **/
        GetSheduleTypeInfo(ids) {
            INTERFACE_MODEL_PETS.GET_SCHEDULE_TYPE_LIST({ids:ids,p:1,rollpage:10000}).then((res) => {
                 if(res.status > 0) return false;
                 this.typelist=res.data.list;
                 for(var i in this.typelist) this.typelist[i].pid=this.typelist[i].pid==0 ? this.typelist[i].pid='' : this.typelist[i].pid;
            });
        },


        /** 获取宠物类型信息 **/
        GetParentTypes() {
            INTERFACE_MODEL_PETS.GET_SCHEDULE_TYPE_LIST({pid:0,p:1,rollpage:100000}).then((res) => {
                 if(res.status > 0) return false;
                 this.fatherlist=res.data.list;
            });
        },


        /** 数据保存到浏览器 **/
        SaveDataToBrowser() {
            var data=JSON.stringify(this.typelist);
            localStorage.setItem('editsheduletypedata',data);
        },

        /** 从浏览器取数据解析 **/
        ParseDataFromBrowser() {
            var data=localStorage.getItem('editsheduletypedata');
            data ? data : data=[];
            
            !data || data=='' || data==[] ? 
            this.typelist=[{name:'',thumb:'',thumbdefault:'',pid:''}] : 
            this.typelist=JSON.parse(data);
        },

        /** 返回宠物管理组件 **/
        GoBackPets(isdellocal) {
            var navinfo={name:'日程类型管理',labelentry:'ScheduleType',components:'ScheduleType',isshow:false};
            var data={Method:''};
            if(isdellocal) data.delcomponents='EditScheduleType'; //跳转后要删除的组件
            var obj={nav:navinfo,data:data};
            this.$parent.ChildCompententAdd(obj); //打开新窗口进行处理
        },

    },
}
</script>
<style scoped>
.TTL-image-box-large {cursor: pointer;width:auto !important;}
.TTL-image-box-large .el-image {width:120px;height:120px;display: inline-block;border-radius: 5px;}
.TTL-image-box-large span {display: inline-block;font-size:12px;margin-left:20px;color:#f56c6c;}
.TTL-btn-option {display:inline-block;margin-right:20px;}
::v-deep(.TTL-radio .el-radio__label) {display: inline-flex !important;align-items: center !important;}
.TTL-radio .el-image {width:18px;height: 18px;}
.petTitle {padding:30px 0 20px 0;}
</style>